import { VersionReportVersionEntity } from '../../../../domain/entity/version-report/VersionReportVersionEntity'
import { SaveVersionReportBatchParams } from '../../../../applications/ports/versionReportVersionRepository'
import { createDelta } from '../../../../domain/value-object/ItemDeltaInputVO'

// lockVersion はサーバー確定値(baseline)を使う
export const computeVersionReportDiff = (
  baseline: VersionReportVersionEntity | undefined,
  draft: VersionReportVersionEntity | undefined
): SaveVersionReportBatchParams => {
  if (!baseline || !draft) {
    return { versionUuid: draft?.uuid ?? '', pages: [], rows: [] }
  }

  const baselinePageByUuid = new Map(baseline.pages.map(p => [p.uuid, p]))
  const baselineRowByUuid = new Map(
    baseline.pages.flatMap(p => p.rows).map(r => [r.uuid, r])
  )

  const pages = draft.pages.flatMap(page => {
    const baselinePage = baselinePageByUuid.get(page.uuid)
    if (!baselinePage) return []
    const pageTitle = createDelta<string>(
      baselinePage.pageTitle,
      page.pageTitle
    )
    const leadSentence = createDelta<string>(
      baselinePage.leadSentence,
      page.leadSentence
    )
    if (!pageTitle && !leadSentence) {
      return []
    }
    return [
      {
        versionPageUuid: page.uuid,
        lockVersion: baselinePage.lockVersion,
        pageTitle,
        leadSentence,
      },
    ]
  })

  const rows = draft.pages.flatMap(page =>
    page.rows.flatMap(row => {
      const baselineRow = baselineRowByUuid.get(row.uuid)
      if (!baselineRow) return []

      const status = createDelta<string>(baselineRow.status, row.status)
      const comment = createDelta<string>(baselineRow.comment, row.comment)
      const displayOrder = createDelta<number>(
        baselineRow.displayOrder,
        row.displayOrder
      )

      if (!status && !comment && !displayOrder) {
        return []
      }

      return [
        {
          rowUuid: row.uuid,
          lockVersion: baselineRow.lockVersion,
          status,
          comment,
          displayOrder,
        },
      ]
    })
  )

  return { versionUuid: draft.uuid, pages, rows }
}
